import { PermissionGateModal } from '../../../common/home/components/PermissionGateModal';
import { useAppNavigate } from '../../../common/hooks/useAppNavigate';
import { usePageTitle } from '../../../common/routes/PageTitle';
import { BaseModal } from '../../../common-ui/modal/BaseModal';
import { Permission } from '../../../services/authentication/utils/authUtils';
import { IntermodalBookingCreateModalContainer } from './IntermodalBookingCreateModalContainer';

export const IntermodalBookingCreateModal = () => {
  const { pop } = useAppNavigate();
  usePageTitle('Create intermodal booking');

  return (
    <PermissionGateModal permission={Permission.EditIntermodalBookings} onRequestClose={pop}>
      <BaseModal onRequestClose={pop}>
        <IntermodalBookingCreateModalContainer onClose={pop} />
      </BaseModal>
    </PermissionGateModal>
  );
};
